/**
 * Created by anatoly on 20.12.2024
 */

const MergeComponentView = function (component, unitView) {
    this.unitView = unitView;
};

MergeComponentView.prototype.highlightMergeError = function (affected) {
    this.highlightUnits(affected, true);
};

MergeComponentView.prototype.highlightMergeHint = function (affected) {
    this.highlightMerge(affected);
};

MergeComponentView.prototype.highlightMerge = function (affected) {
    const target = affected[0];
    this.startAnimateMerge(this.unitView);

    this.highlightUnits(affected, false, (affectedUnit) => {
        const distance = this.calculateDistance(affectedUnit, target);
        if (affectedUnit.distanceTo(target) > 2) {
            distance.dx /= 2;
            distance.dy /= 2;
        }

        this.startAnimateMerge(affectedUnit.view, distance);
    });
};

MergeComponentView.prototype.calculateDistance = function (affectedUnit, target) {
    const mapView = Map2d.currentMap.getMapView();
    const targetPosition = mapView.alignInGrid(target.x, target.y);

    const x = affectedUnit.x;
    const y = affectedUnit.y;

    const position = mapView.alignInGrid(x, y);

    let dx = targetPosition.x - position.x;
    let dy = targetPosition.y - position.y;

    const length = Math.sqrt(dx * dx + dy * dy);
    if (length <= 0) {
        return { dx: 0, dy: 0 };
    }

    dx = dx / length * cleverapps.styles.MergeComponentView.highlightLength;
    dy = dy / length * cleverapps.styles.MergeComponentView.highlightLength;

    return { dx, dy };
};

MergeComponentView.prototype.highlightUnits = function (affected, isErrorLight, additionalAnimation) {
    this.highlightedUnits = affected;

    affected.forEach(function (p) {
        const x = p.x;
        const y = p.y;

        const affectedUnit = Map2d.currentMap.getUnit(x, y);
        affectedUnit.unhighlight();

        const light = affectedUnit.lightMerge = new Highlight(x, y, {
            isErrorLight,
            unit: this.unit
        });

        additionalAnimation && additionalAnimation(affectedUnit);

        Map2d.currentMap.onAdd(Map2d.LAYER_UNITS, x, y, light);
    }, this);
};

MergeComponentView.prototype.unhighlightMerge = function () {
    if (!this.highlightedUnits) {
        return;
    }

    this.stopAnimateMerge(this.unitView);
    cleverapps.centerHint.finishCenterHint();

    this.highlightedUnits.forEach(function (p) {
        const affectedUnit = Map2d.currentMap.getUnit(p.x, p.y);

        if (!affectedUnit) {
            return;
        }

        if (affectedUnit.lightMerge) {
            affectedUnit.lightMerge.remove();
            delete affectedUnit.lightMerge;
        }

        this.stopAnimateMerge(affectedUnit.view, p);
    }, this);

    this.highlightedUnits = undefined;
};

MergeComponentView.prototype.showMergeCount = function ({ count, x, y }) {
    if (count < 3) {
        return;
    }

    if (!cleverapps.user.checkAvailable(cleverapps.config.availables.MERGE_COUNTER)) {
        return;
    }

    if (Map2dLocation.currentLocation && Map2dLocation.currentLocation.tutorial.isActive()) {
        return;
    }

    const styles = cleverapps.styles.MergeComponentView.mergeCount;
    const bgFrame = bundles.merge.frames.merge_count_png;
    const bg = new cc.Sprite(bgFrame);
    bg.setScale(styles.size.width / bg.width);
    const amountText = cleverapps.UI.generateImageText(count, cleverapps.styles.FONTS.MERGE_COUNT_TEXT);
    amountText.setScale(bg.width / styles.size.width);
    amountText.fitTo(styles.text.size.width);
    bg.addChild(amountText);
    amountText.setPosition(bg.width / 2, bg.height / 2 + styles.text.dy);

    const affectedUnit = Map2d.currentMap.getUnit(x, y);
    const unitView = affectedUnit.onGetView();
    bg.setPosition(unitView.width / 2, unitView.height + styles.dy);
    unitView.addChild(bg);

    this.mergeCountView = bg;
};

MergeComponentView.prototype.hideMergeCount = function () {
    if (this.mergeCountView) {
        this.mergeCountView.removeFromParent();
        this.mergeCountView = null;
    }
};

MergeComponentView.prototype.startAnimateMerge = function (unitView, distance) {
    if (!unitView) {
        return;
    }

    this.cleanAnimations(unitView);

    const actions = [];
    actions.push(new cc.Sequence(
        new cc.ScaleTo(0.325, 1.03),
        new cc.ScaleTo(0.325, 1),
        new cc.DelayTime(0.1)
    ));

    if (distance) {
        const dx = distance.dx;
        const dy = distance.dy;

        if (cleverapps.gameModes.automerge && Map2d.currentMap.advice && !Map2d.currentMap.advice.hintActive) {
            actions.push(new cc.Sequence(
                new cc.MoveBy(0.33, -dx, -dy).easing(cc.easeBackOut()),
                new cc.DelayTime(0.2),
                new cc.MoveBy(0.22, dx, dy).easing(cc.easeBackIn())
            ));
        } else {
            actions.push(new cc.Sequence(
                cleverapps.effects.fireAction("merge.hint"),
                new cc.MoveBy(0.450, dx, dy).easing(cc.easeBackIn()),
                new cc.MoveBy(0.2, -dx, -dy).easing(cc.easeOut(2)),
                new cc.DelayTime(0.1)
            ));
        }
    }

    const action = actions.length === 1 ? actions[0] : new cc.Spawn(actions);
    unitView.mergeAnimateAction = unitView.runAction(new cc.RepeatForever(action));

    if (distance) {
        const basePosition = Map2d.currentMap.getMapView().alignInGrid(unitView.unit.x, unitView.unit.y);
        unitView.mergeAnimateAction.setFinalize(() => {
            unitView.setPosition(basePosition);
        });
    }
};

MergeComponentView.prototype.stopAnimateMerge = function (unitView, unitPosition) {
    if (!unitView) {
        return;
    }

    this.cleanAnimations(unitView);

    const actions = [];

    if (unitPosition && (!unitView.mergeAction || unitView.mergeAction.isDone())) {
        actions.push(new cc.MoveTo(0.1, Map2d.currentMap.getMapView().alignInGrid(unitPosition.x, unitPosition.y)));
    }
    actions.push(new cc.ScaleTo(0.1, 1));

    unitView.mergeAnimateAction = unitView.runAction(actions.length > 1 ? new cc.Spawn(actions) : actions[0]);
};

MergeComponentView.prototype.cleanAnimations = function (unitView) {
    if (unitView.raysAnimation) {
        unitView.raysAnimation.setAnimation(0, "close", false);
        unitView.raysAnimation.setCompleteListenerRemove();
        delete unitView.raysAnimation;

        unitView.restoreOpacity();
    }

    if (unitView.mergeAnimateAction && !unitView.mergeAnimateAction.isDone()) {
        unitView.stopAction(unitView.mergeAnimateAction);
        delete unitView.mergeAnimateAction;
    }
};

cleverapps.styles.MergeComponentView = {
    highlightLength: 16,

    mergeCount: {
        size: { width: 63, height: 74 },
        dy: 70,

        text: {
            size: { width: 56 },
            dy: 10
        }
    }
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    MERGE_COUNT_TEXT: {
        size: 40,
        color: cleverapps.styles.FONTS.LIGHT_TEXT_COLOR
    }
});
